import React from "react";
import Noimg from "../images/no_img.jpg";
import tw from "twin.macro";
import upip from "../../src/images/Thanshiq/diamond mainpage/upi-icon.png"
import { FormGroup } from "react-bootstrap";
// eslint-disable-next-line
const Heading = tw.h1`text-center`;
const toPascalCase = (text) => {
  if (!text) return ''; 

  return text
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export default function OrderDetails({ viewCart, total }) {
  return (
    <div className="col-md-4  my-sm-0 my-4" >
      <div className="max-w-md mx-auto  shadow-lg rounded-lg md:max-w-xl mx-2 r" style={{ background: "		#F5FFFA" }}>
        <div className="px-5 " tw="py-2 border-b-4 border-custom-100 " >
          <b className="checkOutTop">ORDER SUMMARY</b>
        </div>
        <div className="m-2" style={{ margin: "10px" }}>
          <span className="m-3 checkOutsub d-flex justify-content-between " style={{ marginLeft: "5px" }}>
            Sub Total <span className="checkOutsub">₹{Math.trunc(total).toString()} </span>
          </span>
          <span className="m-3 checkOutsub d-flex justify-content-between" style={{ marginLeft: "5px" }}>
            Discount <span className="checkOutsub">{Math.trunc(total).toString()}</span>
          </span>
          {/* <span className=" m-3 checkOutsub d-flex justify-content-between" style={{ marginLeft: "5px" }}>
            Delivery Charge<span className="text-success">Free</span>
          </span> */}
          <span className="m-3 totalStyle d-flex justify-content-between" style={{ marginLeft: "5px" }}>
            TOTAL (Incl of all Taxes.) <span className="checkOutsub">₹{Math.trunc(total).toString()} </span>
          </span>
          {/* <span className=" m-3 yousave d-flex justify-content-between" style={{ marginLeft: "5px" }}>
            You Save  <span className="yousave">+₹2324 </span>
          </span> */}
          <span className="m-3  totalStyle d-flex justify-content-between" style={{ marginLeft: "5px" }}>
            AMOUNT PAYABLE (Incl of all Taxes.) <span className="totalStyle">₹{Math.trunc(total).toString()} </span>
          </span>
        </div>
        <div className="price-detail-section orderItem-box " tw="border border-custom-100 " style={{ position: "absolute", bottom: "5px" }}>
          <div className="row">
            <div className="label-col col-sm-7 col ">
              <small className="inc-tax" tw="text-xs">
                {" "}
              </small>
            </div>
            <div className="price-col col-sm-5 col">
            </div>
          </div>
        </div>
      </div>
      <div>
      </div>
      <div >
        <div style={{ position: "relative", width: "400px", background: "white", color: "black" }}>
        </div>
      </div>
      <div>
        <table className="bg-white" style={{ border: "1px solid lightgray", width: "100%" }}>
          <tbody>
            {
            }
            {viewCart.map((list, index) => (
              <>
                <tr key={index}>
                  <td>
                    <td>
                      <img
                        src={
                          list.images === "Image_Not_Available" || list.images === "-" || list.images === null || list.images === "@#@"
                            ? Noimg
                            : list.images?.split("@#@")[0]
                        }
                        alt="MGDM Jewellers-product"
                        tw="w-20"
                      />
                    </td>
                    <td>
                      <div className="ms-4 ">
                        <span className="smallBoxTitile" >{toPascalCase(list.productName)}</span>
                        <p className=" smallBoxId" >
                          {list.productCode}
                        </p>
                        <small className="smallBoxQty" >
                          Qty:
                          {/* {viewCart.length} */}{list.quantity}
                        </small>
                      </div>
                    </td>
                  </td>
                  <td>
                  </td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
      </div>
<div id="sticky-footer" className="p-2" style={{ borderTop: "1px solid #832729" }}>        <div className="cartBottomFont" style={{ marginRight: "20px" }}> Total <span className="cartBottomCount">({viewCart.length}item)</span>: ₹{Math.trunc(total).toString()} </div>
        <div style={{ marginRight: "20px" }}>  </div>
        <button className="cardPageCheck " > Proceed to Buy </button>
      </div>
    </div>

  );
}
